/* Secret Scenta — product page behaviour.
   Without JS the form still posts to /cart/add and the first frame shows. */
(() => {
  'use strict';

  const root = document.querySelector('[data-pdp]');
  if (!root) return;

  const product = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const form = root.querySelector('form[action*="/cart/add"]');
  const idInput = root.querySelector('[data-variant-id]');
  const atc = root.querySelector('[data-atc]');
  const atcLabel = root.querySelector('[data-atc-label]');
  const addedNote = root.querySelector('[data-added-note]');
  const unavailableNote = root.querySelector('[data-unavailable-note]');
  const priceEl = root.querySelector('.pdp__price-value');
  const sticky = root.querySelector('[data-sticky-atc]');
  const stickyVariant = root.querySelector('[data-sticky-variant]');
  const stickyPrice = root.querySelector('.pdp-sticky__price');
  const stickyAdd = root.querySelector('[data-sticky-add]');
  const stickyLabel = root.querySelector('[data-sticky-label]');
  const strings = {
    add: atcLabel ? atcLabel.textContent.trim() : 'Ajouter au panier',
    // from the locale via the button, never hardcoded — the store is French-first
    soldOut: (atc && atc.dataset.soldOutLabel) || 'Épuisé',
  };

  const currency = document.documentElement.lang && Intl
    ? new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: root.dataset.currency || 'EUR',
      })
    : null;
  const money = (cents) => (currency ? currency.format(cents / 100) : (cents / 100).toFixed(2));

  /* Price with an optional struck-through original — mirrors snippets/price.liquid.
     Must REBUILD the child nodes rather than set textContent: the server renders
     <span class="money-now"> + <s class="money-was">, and blanking it with
     textContent drops the compare-at price on the very first variant swap. */
  function renderPrice(el, variant) {
    if (!el) return;
    const compare = variant.compare_at_price;
    if (compare && compare > variant.price) {
      const now = document.createElement('span');
      now.className = 'money-now';
      now.textContent = money(variant.price);
      const was = document.createElement('s');
      was.className = 'money-was';
      was.textContent = money(compare);
      el.replaceChildren(now, ' ', was);
      el.classList.add('is-sale');
    } else {
      el.replaceChildren(money(variant.price));
      el.classList.remove('is-sale');
    }
  }

  /* ---------- gallery ---------- */
  const gallery = root.querySelector('[data-gallery]');
  const frames = [...root.querySelectorAll('[data-frame]')];
  const thumbs = [...root.querySelectorAll('[data-thumb]')];
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function showFrame(index) {
    frames.forEach((f, i) => f.classList.toggle('is-active', i === index));
    // thumbs carry their frame index in data-thumb — the strip may hide some
    // frames (per-finish variant images), so array position can't be trusted
    thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.thumb) === index));
    // On mobile the gallery is a swipe carousel: every frame is always rendered
    // and .is-active has no visual effect, so bring the chosen frame into view
    // by scrolling the strip itself (no page scroll — we move gallery.scrollLeft).
    const target = frames[index];
    if (target && gallery && gallery.scrollWidth > gallery.clientWidth + 1) {
      const delta = target.getBoundingClientRect().left - gallery.getBoundingClientRect().left
        - (gallery.clientWidth - target.clientWidth) / 2;
      gallery.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }
  thumbs.forEach((t) => t.addEventListener('click', () => showFrame(Number(t.dataset.thumb))));

  /* ---------- per-finish gallery re-dress ----------
     finish_swap: { "<finish value>": { "<frame index>": "<img url>", … } }
     The listed frames (packshot, macro) change to the chosen finish; every
     other frame restores to its original. Lifestyle frames never swap. */
  const finishSwapEl = root.querySelector('[data-finish-swap]');
  const finishSwap = finishSwapEl ? JSON.parse(finishSwapEl.textContent || 'null') : null;
  const frameImgs = frames.map((f) => f.querySelector('img'));
  const frameOriginals = frameImgs.map((img) =>
    img ? { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') } : null
  );
  const thumbImgsByFrame = {};
  thumbs.forEach((t) => {
    const img = t.querySelector('img');
    if (img) thumbImgsByFrame[Number(t.dataset.thumb)] = { img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') };
  });
  function setImg(img, url, orig) {
    if (!img || !orig) return;
    if (url) {
      img.setAttribute('src', url);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    } else {
      img.setAttribute('src', orig.src);
      if (orig.srcset) img.setAttribute('srcset', orig.srcset); else img.removeAttribute('srcset');
      if (orig.sizes) img.setAttribute('sizes', orig.sizes); else img.removeAttribute('sizes');
    }
  }
  function applyFinishSwap(variant) {
    if (!finishSwap || !variant) return false;
    const map = finishSwap[variant.option1] || finishSwap[variant.title] || null;
    frames.forEach((f, i) => {
      const url = map ? map[i] : null;
      setImg(frameImgs[i], url, frameOriginals[i]);
      const t = thumbImgsByFrame[i];
      if (t) setImg(t.img, url, t);
    });
    if (map) showFrame(0);
    return Boolean(map);
  }

  /* ---------- variant selection ---------- */
  function selectedOptions() {
    return [...root.querySelectorAll('.pdp__options')].map(
      (fs) => fs.querySelector('input:checked')?.value
    );
  }

  function findVariant(options) {
    return product.variants.find((v) =>
      options.every((value, i) => !value || v.options[i] === value)
    );
  }

  function updateBuyState(variant) {
    const available = Boolean(variant && variant.available);
    if (atc) atc.disabled = !available;
    if (stickyAdd) stickyAdd.disabled = !available;
    const label = available ? strings.add : strings.soldOut;
    if (atcLabel) atcLabel.textContent = label;
    if (stickyLabel) stickyLabel.textContent = label;
    if (unavailableNote) unavailableNote.hidden = available;
  }

  function onVariantChange() {
    const variant = findVariant(selectedOptions());
    if (!variant) {
      updateBuyState(null);
      return;
    }
    idInput.value = variant.id;
    renderPrice(priceEl, variant);
    if (stickyVariant) stickyVariant.textContent = variant.title;
    renderPrice(stickyPrice, variant);
    updateBuyState(variant);

    // re-dress the gallery in the chosen finish; otherwise fall back to
    // jumping to the variant's own image if it has one
    const swapped = applyFinishSwap(variant);
    if (!swapped && variant.featured_media) {
      // match by media id on the frame itself — product.media positions don't
      // line up with frame indices once " — détail" media are skipped as frames
      const index = frames.findIndex((f) => Number(f.dataset.mediaId) === variant.featured_media.id);
      if (index >= 0) showFrame(index);
    }

    // active pill / swatch styling
    root.querySelectorAll('.pdp__option, .pdp__swatch').forEach((label) => {
      const input = label.querySelector('input');
      label.classList.toggle('is-active', input.checked);
    });
    // reflect the picked value beside the option name (finish swatches)
    root.querySelectorAll('[data-option-selected]').forEach((el) => {
      const fs = el.closest('.pdp__options');
      const checked = fs && fs.querySelector('input:checked');
      if (checked) el.textContent = checked.value;
    });

    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  root.querySelectorAll('[data-option-value]').forEach((input) =>
    input.addEventListener('change', onVariantChange)
  );

  /* ---------- fragrance upsell (the 'fragrance_upsell' block) ----------
     MULTI-SELECT: a shopper may pick several fragrances; each adds one line.
     Cards are buttons with data-* only — nothing named — so they never enter the
     form's FormData. addToCart() posts the diffuser plus every chosen scent. */
  const upsell = root.querySelector('[data-pdp-upsell]');
  const upsellNote = root.querySelector('[data-upsell-note]');
  const pickedScents = () => (upsell ? [...upsell.querySelectorAll('[data-scent-pick].is-selected')] : []);
  if (upsell) {
    const saving = Number(upsell.dataset.coffretSaving) || 20;
    const picks = [...upsell.querySelectorAll('[data-scent-pick]')];
    const refreshNote = () => {
      if (!upsellNote) return;
      const sel = pickedScents();
      if (!sel.length) { upsellNote.hidden = true; return; }
      // the saving is per diffuser+fragrance pair, so one diffuser earns it once
      // however many fragrances are chosen — say that plainly rather than imply more
      const label = sel.length === 1
        ? sel[0].dataset.title
        : sel.length + ' parfums sélectionnés';
      upsellNote.textContent = label + ' — −' + saving + ' € sur votre coffret';
      upsellNote.hidden = false;
    };
    picks.forEach((b) => {
      b.addEventListener('click', () => {
        if (b.hasAttribute('disabled')) return;
        const nowSelected = !b.classList.contains('is-selected');
        b.classList.toggle('is-selected', nowSelected);
        b.setAttribute('aria-pressed', String(nowSelected));
        refreshNote();
      });
    });
  }

  /* ---------- quantity ---------- */
  const qtyInput = root.querySelector('.qty__input');
  root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
  });
  root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
  });

  /* ---------- add to cart (AJAX; falls back to normal POST without JS) ---------- */
  let adding = false;
  async function addToCart() {
    if (adding || !form) return;
    adding = true;
    const root_url = window.Shopify?.routes?.root || '/';
    try {
      const picked = pickedScents();
      let response;
      if (picked.length) {
        // diffuser + chosen scent in ONE atomic add — /cart/add.js only accepts
        // multiple line items via the JSON {items:[…]} body, not FormData.
        const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10));
        response = await fetch(`${root_url}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(idInput.value), quantity: qty },
              ...picked.map((p) => ({ id: Number(p.dataset.scentId), quantity: 1 })),
            ],
          }),
        });
      } else {
        response = await fetch(`${root_url}cart/add.js`, {
          method: 'POST',
          body: new FormData(form),
        });
      }
      if (!response.ok) throw new Error('add failed');
      const cartRes = await fetch(`${root_url}cart.js`);
      const cart = await cartRes.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:open-drawer'));
      if (addedNote) {
        addedNote.hidden = false;
      }
    } catch {
      form.submit(); // graceful fallback to the full-page flow
    } finally {
      adding = false;
    }
  }

  form?.addEventListener('submit', (e) => {
    e.preventDefault();
    addToCart();
  });
  stickyAdd?.addEventListener('click', addToCart);

  /* ---------- sticky bar visibility ---------- */
  const buyBox = root.querySelector('[data-buy-box]');
  if (buyBox && sticky && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      },
      { threshold: 0 }
    );
    io.observe(buyBox);
  }
})();
